import React from "react";
import styled, { keyframes } from "styled-components";

const Spinner = ({
  fontSize,
  color = { r: "219", g: "219", b: "219" },
  position,
  top,
  right,
  bottom,
  left,
}) => {
  return (
    <Container
      fontSize={fontSize}
      color={color}
      position={position}
      top={top}
      right={right}
      bottom={bottom}
      left={left}
    >
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
    </Container>
  );
};

export default Spinner;

const Keyframes = ({ r, g, b }) => keyframes`
  0%,
  100% {
    box-shadow: 0em -2.6em 0em 0em rgba(${r}, ${g}, ${b}, 1),
      1.8em -1.8em 0 0em rgba(${r}, ${g}, ${b}, 0.2),
      2.5em 0em 0 0em rgba(${r}, ${g}, ${b}, 0.2),
      1.75em 1.75em 0 0em rgba(${r}, ${g}, ${b}, 0.2),
      0em 2.5em 0 0em rgba(${r}, ${g}, ${b}, 0.2),
      -1.8em 1.8em 0 0em rgba(${r}, ${g}, ${b}, 0.2),
      -2.6em 0em 0 0em rgba(${r}, ${g}, ${b}, 0.5),
      -1.8em -1.8em 0 0em rgba(${r}, ${g}, ${b}, 0.7);
  }
  12.5% {
    box-shadow: 0em -2.6em 0em 0em rgba(${r}, ${g}, ${b}, 0.7),
      1.8em -1.8em 0 0em rgba(${r}, ${g}, ${b}, 1),
      2.5em 0em 0 0em rgba(${r}, ${g}, ${b}, 0.2),
      1.75em 1.75em 0 0em rgba(${r}, ${g}, ${b}, 0.2),
      0em 2.5em 0 0em rgba(${r}, ${g}, ${b}, 0.2),
      -1.8em 1.8em 0 0em rgba(${r}, ${g}, ${b}, 0.2),
      -2.6em 0em 0 0em rgba(${r}, ${g}, ${b}, 0.2),
      -1.8em -1.8em 0 0em rgba(${r}, ${g}, ${b}, 0.5);
  }
  25% {
    box-shadow: 0em -2.6em 0em 0em rgba(${r}, ${g}, ${b}, 0.5),
      1.8em -1.8em 0 0em rgba(${r}, ${g}, ${b}, 0.7),
      2.5em 0em 0 0em rgba(${r}, ${g}, ${b}, 1),
      1.75em 1.75em 0 0em rgba(${r}, ${g}, ${b}, 0.2),
      0em 2.5em 0 0em rgba(${r}, ${g}, ${b}, 0.2),
      -1.8em 1.8em 0 0em rgba(${r}, ${g}, ${b}, 0.2),
      -2.6em 0em 0 0em rgba(${r}, ${g}, ${b}, 0.2),
      -1.8em -1.8em 0 0em rgba(${r}, ${g}, ${b}, 0.2);
  }
  37.5% {
    box-shadow: 0em -2.6em 0em 0em rgba(${r}, ${g}, ${b}, 0.2),
      1.8em -1.8em 0 0em rgba(${r}, ${g}, ${b}, 0.5),
      2.5em 0em 0 0em rgba(${r}, ${g}, ${b}, 0.7),
      1.75em 1.75em 0 0em rgba(${r}, ${g}, ${b}, 1),
      0em 2.5em 0 0em rgba(${r}, ${g}, ${b}, 0.2),
      -1.8em 1.8em 0 0em rgba(${r}, ${g}, ${b}, 0.2),
      -2.6em 0em 0 0em rgba(${r}, ${g}, ${b}, 0.2),
      -1.8em -1.8em 0 0em rgba(${r}, ${g}, ${b}, 0.2);
  }
  50% {
    box-shadow: 0em -2.6em 0em 0em rgba(${r}, ${g}, ${b}, 0.2),
      1.8em -1.8em 0 0em rgba(${r}, ${g}, ${b}, 0.2),
      2.5em 0em 0 0em rgba(${r}, ${g}, ${b}, 0.5),
      1.75em 1.75em 0 0em rgba(${r}, ${g}, ${b}, 0.7),
      0em 2.5em 0 0em rgba(${r}, ${g}, ${b}, 1),
      -1.8em 1.8em 0 0em rgba(${r}, ${g}, ${b}, 0.2),
      -2.6em 0em 0 0em rgba(${r}, ${g}, ${b}, 0.2),
      -1.8em -1.8em 0 0em rgba(${r}, ${g}, ${b}, 0.2);
  }
  62.5% {
    box-shadow: 0em -2.6em 0em 0em rgba(${r}, ${g}, ${b}, 0.2),
      1.8em -1.8em 0 0em rgba(${r}, ${g}, ${b}, 0.2),
      2.5em 0em 0 0em rgba(${r}, ${g}, ${b}, 0.2),
      1.75em 1.75em 0 0em rgba(${r}, ${g}, ${b}, 0.5),
      0em 2.5em 0 0em rgba(${r}, ${g}, ${b}, 0.7),
      -1.8em 1.8em 0 0em rgba(${r}, ${g}, ${b}, 1),
      -2.6em 0em 0 0em rgba(${r}, ${g}, ${b}, 0.2),
      -1.8em -1.8em 0 0em rgba(${r}, ${g}, ${b}, 0.2);
  }
  75% {
    box-shadow: 0em -2.6em 0em 0em rgba(${r}, ${g}, ${b}, 0.2),
      1.8em -1.8em 0 0em rgba(${r}, ${g}, ${b}, 0.2),
      2.5em 0em 0 0em rgba(${r}, ${g}, ${b}, 0.2),
      1.75em 1.75em 0 0em rgba(${r}, ${g}, ${b}, 0.2),
      0em 2.5em 0 0em rgba(${r}, ${g}, ${b}, 0.5),
      -1.8em 1.8em 0 0em rgba(${r}, ${g}, ${b}, 0.7),
      -2.6em 0em 0 0em rgba(${r}, ${g}, ${b}, 1),
      -1.8em -1.8em 0 0em rgba(${r}, ${g}, ${b}, 0.2);
  }
  87.5% {
    box-shadow: 0em -2.6em 0em 0em rgba(${r}, ${g}, ${b}, 0.2),
      1.8em -1.8em 0 0em rgba(${r}, ${g}, ${b}, 0.2),
      2.5em 0em 0 0em rgba(${r}, ${g}, ${b}, 0.2),
      1.75em 1.75em 0 0em rgba(${r}, ${g}, ${b}, 0.2),
      0em 2.5em 0 0em rgba(${r}, ${g}, ${b}, 0.2),
      -1.8em 1.8em 0 0em rgba(${r}, ${g}, ${b}, 0.5),
      -2.6em 0em 0 0em rgba(${r}, ${g}, ${b}, 0.7),
      -1.8em -1.8em 0 0em rgba(${r}, ${g}, ${b}, 1);
  } 
`;

const Container = styled.div`
  margin: 0 auto;
  font-size: ${({ fontSize }) => (fontSize ? fontSize : "10px")};
  width: 1em;
  height: 1em;
  border-radius: 50%;
  position: ${({ position }) => (position ? position : "")};
  top: ${({ top }) => (top ? top : "")};
  right: ${({ right }) => (right ? right : "")};
  bottom: ${({ bottom }) => (bottom ? bottom : "")};
  left: ${({ left }) => (left ? left : "")};
  animation: ${({ color }) => Keyframes(color)} 1.1s infinite ease;
`;
